import { GatewayChargingSessionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/charging-sessions/gateway-charging-session.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { EmspBoChargingSessionListEmspUserEmailAddressCell } from './emsp-bo-charging-session-list-emsp-user-email-address.cell';
import { EmspBoChargingSessionListEmspUserEmailAddressHeader } from './emsp-bo-charging-session-list-emsp-user-email-address.header';

export const EmspBoChargingSessionListEmspUserEmailAddressColumn: IdentifiedColumnDef<
  GatewayChargingSessionModel,
  GatewayChargingSessionModel['emspUser']['emailAddress']
> = {
  id: 'emspUserEmailAddress',
  enableSorting: false,
  header: EmspBoChargingSessionListEmspUserEmailAddressHeader,
  cell: EmspBoChargingSessionListEmspUserEmailAddressCell,
};
